import { gql } from '@apollo/client'

export default gql(`
    mutation retryGracenoteIngestJob($batchJobId: ID! $project: String) {
        retryGracenoteIngestJob(
            batchJobId: $batchJobId
            project: $project
        ) {
            batchID
        }
    }`
)
